import React, { useState } from 'react';
import { Button, Modal } from 'react-bootstrap';
import { StripeForm } from './StripeForm';

interface FormProps {
    show: boolean;
    handleClose: () => void;
    missionaryId: string;
}

export default function SubscriptionForm({ show, handleClose, missionaryId }: FormProps) {
    const [success, setSuccess] = useState(false);

    const handleSuccess = () => {
        setSuccess(true);
        setTimeout(() => {
            setSuccess(false);
            handleClose();
        }, 2000);
    };

    return (
        <Modal 
            show={show} 
            onHide={handleClose} 
            className="modern-modal subscription-modal"
            size="lg"
            centered
        >
            <Modal.Header closeButton className="modal-header">
                <Modal.Title className="modal-title">
                    {success ? 'Payment Successful!' : 'Choose Your Plan'}
                </Modal.Title>
            </Modal.Header>
            
            <Modal.Body className="modal-body">
                {success ? (
                    <div className="success-message text-center py-4">
                        <div className="success-icon mb-3">✓</div>
                        <h4>Welcome aboard!</h4>
                        <p>Your subscription is now active. You can start sending emails right away.</p>
                    </div>
                ) : (
                    <StripeForm 
                        onClose={handleClose} 
                        missionaryId={missionaryId}
                        onSuccess={handleSuccess}
                    />
                )}
            </Modal.Body>
            
            {!success && (
                <Modal.Footer className="modal-footer">
                    <Button 
                        variant="outline-secondary" 
                        onClick={handleClose}
                        className="cancel-btn"
                    >
                        Cancel
                    </Button>
                </Modal.Footer>
            )}
        </Modal>
    );
}
